<prcins-mobile-app
  [allowWebContinue] = false
  [allowAutoRedirect] = true
>
</prcins-mobile-app>
